import Node from "./baseNode";

export default class IntervalNode extends Node {
	static get modelName() {
		return "IntervalNode";
	}

	constructor(k4node) {
		super(k4node);

		const seconds = k4node.child("properties/seconds").value();
		this.readableName = `every ${seconds}s`;
	}

	get isInterval() {
		return true;
	}
}
